<div
    class="agpr-discoverListPicker"
    role="group"
    aria-describedby="dataSource_errors"
>
    <div
        class="agpr-discoverListPicker-inputGroup"
        role="group"
        [attr.aria-label]="'todo'"
    >
        <span
            class="agpr-discoverListPicker-picker"
            [ngClass]="{'agpr-discoverListPicker-picker--withChips': chipsVisible}"
        >
            <agpr-dropdown
                [id]="id + '.targeting.add.to.type'"
                class="agpr-discoverListPicker-picker-dropdown"
                [options]="discoverListTypeOptions"
                [(ngModel)]="selectedListType"
                [bindToValue]="true"
                (ngModelChange)="selectListType()"
            ></agpr-dropdown>

            <agpr-autocomplete
                [id]="id + '_sourceAutocomplete'"
                class="agpr-discoverListPicker-picker-autocomplete"
                [ngClass]="{'agpr-discoverListPicker-picker-autocomplete--disabled' : selectedListType === discoverListTypes.none}"
                labelField="name"
                [placeholder]="('Discover.listPicker.placeholder.' + selectedListType)"
                [dropdown]="true"
                [disabled]="selectedListType === discoverListTypes.none"
                [(ngModel)]="selectedList"
                (itemSelected)="selectSource($event, true)"
                [suggestions]="source$"
                tooltipPosition="top"
                selectedItemsHideKey="id"
                [ariaLabel]="'Discover.listPicker.placeholder.' + selectedListType"
                [showHiddenOption]="true"
                [clearOnBlur]="false"
            ></agpr-autocomplete>
            <div class="agpr-discoverListPicker-filterDropdown">
                <agpr-filter-dropdown
                    [id]="id + '.filters'"
                    class="agpr-discoverListPicker-filterDropdown-filter"
                    [disabled]="!selectedList"
                    [ariaLabel]="'Discover.targeting.filter.quick.label' | localize"
                    [ariaDescribedBy]="id + '.chips'"
                ></agpr-filter-dropdown>
            </div>
        </span>
        <div class="agpr-discoverListPicker-chips-container" *ngIf="chipsVisible">
            <agpr-filter-chips
                [id]="id + '.chips'"
            ></agpr-filter-chips>
        </div>
        <agpr-checkbox
            *ngIf="selectedListType !== discoverListTypes.none"
            [id]="id + 'searchOutlets'"
            [(ngModel)]="searchAssociatedOutlets"
            (ngModelChange)="setDistributionRecipientSearchMode()"
            [binary]="true"
            [label]="selectedListType === discoverListTypes.distribution ? 'Discover.listPicker.searchRecipientOutlets' : 'Discover.listPicker.searchAssociatedOutlets'"
            [infoCircleTooltip]="selectedListType === discoverListTypes.distribution? 'Discover.listPicker.searchRecipientOutlets.tooltip' : 'Discover.listPicker.searchAssociatedOutlets.tooltip'"
        ></agpr-checkbox>
    </div>
    <div *ngIf="selectedList && value?.contactCount !== null" class="agpr-discoverListPicker-contactCount">
        <span> {{ 'Discover.listPicker.totalContactsCount' | localize:{count: value?.contactCount} }} </span>
        <agpr-button
            class="agpr-discoverListPicker-viewSource"
            [style]="buttonTypes.contextMenu"
            icon="fa-regular fa-duotone fa-up-right-from-square"
            [tooltip]="viewSourceTooltip"
            tooltipPosition="top"
            [initiallyFocusable]="false"
            (click)="viewSource()"
        ></agpr-button>
    </div>
</div>



